import React from 'react';
import _ from 'lodash';
import Autocomplete from 'components/base/Autocomplete';
import { SPACES } from 'common/constants/sizes';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import { useSelector } from 'react-redux';
import { repositoriesWithProviderDetails } from 'state/selectors/repositories';
import styled from 'styled-components';

const ProviderLogo = styled.img`
  width: 1.5rem;
  height: 1.5rem;
`;

const genreateRepositoresDropdownOptions = repositories => {
  return [
    { value: null, displayValue: 'Select Repository', searchableValue: '' },
    ..._.chain(repositories)
      .orderBy('name')
      .map(repo => generateDropdownOption(repo))
  ];
};

const generateDropdownOption = repo => {
  const providerLogo = _.get(repo, 'provider.logo');
  return {
    value: repo,
    searchableValue: _.get(repo, 'name'),
    displayValue: (
      <Flex items='center' key={_.get(repo, 'id')}>
        {providerLogo && <ProviderLogo src={providerLogo} />}
        <Text pl={SPACES.small} size='medium' ellipsisAfter>
          {_.get(repo, 'name')}
        </Text>
      </Flex>
    )
  };
};

const RepositoriesAutocomplete = ({ onChange, selectedRepo }) => {
  const repositories = useSelector(repositoriesWithProviderDetails);

  const placeholder = selectedRepo
    ? _.get(selectedRepo, 'name')
    : 'Select Repository';

  return (
    <Autocomplete
      placeholder={placeholder}
      options={genreateRepositoresDropdownOptions(repositories)}
      onChange={onChange}
      getOptionSelected={(option, value) =>
        _.get(option, 'value.id') === _.get(value, 'id')
      }
      selectedOptionValue={
        selectedRepo ? selectedRepo.name : 'Select Repository'
      }
      width='100%'
      dataCy='repositories-autocomplete'
    />
  );
};
export default RepositoriesAutocomplete;
